import mediaQ from 'responsive/utils/mediaQueries.module.scss'

export const mediaQueries = [
	mediaQ.issmall,
	mediaQ.ismedium,
	mediaQ.islarge,
	mediaQ.isextralarge,
]
